export const MAGIC_RAFFLE_FAQ_ITEMS = [
  {
    question: 'How do I participate in Magic Raffles?',
    answer:
      'To participate in Magic Raffles, simply select the number of tickets you wish to purchase. Tickets can be purchased using either USDT or SQR. If you pay in USDT, you will pay the fixed USD ticket price, such as $3 per ticket. If you pay in SQR, you will pay the equivalent value of $3 worth of SQR, based on the SQR/USDT price at the start of the raffle. All participants compete for the same unified prize pool, regardless of the currency used.',
  },
  {
    question: 'How is the ticket price determined?',
    answer:
      'The ticket price is pegged to a fixed USD value, determined at the start of each raffle (e.g., $3 per ticket). If you pay with USDT (BEP20), the price remains fixed for the entire raffle. If you choose to pay with SQR, the price is calculated dynamically based on the USDT/SQR rate at the time each ticket is purchased.',
  },
  {
    question: 'How is the prize pool managed?',
    answer:
      'The prize pool is entirely held in SQR. For transparency, the prize pool’s estimated USD value is displayed in the dApp, reflecting the current SQR/USDT rate. This allows participants to see the approximate value of the rewards in both SQR and USD.',
  },
  {
    question: 'How are rewards distributed?',
    answer:
      'At the end of the raffle, the winner is selected using a random number generated by Chainlink VRF, ensuring fairness and transparency. Rewards are then distributed in SQR directly to the winner’s wallet. There is no need for manual claims as the process is automated.',
  },
  {
    question: 'How are ticket funds allocated?',
    answer:
      'When a ticket is purchased with USDT, 70% of the funds go to the prize pool, 15% are allocated to the treasury, and 15% are used for buy-back-and-burn operations to support the SQR token. When a ticket is purchased with SQR, 70% goes to the prize pool, 15% goes to the treasury, and 15% is directly burned to reduce the total supply of SQR.',
  },
  {
    question: 'How often does a new raffle start?',
    answer:
      'A new raffle begins automatically as soon as the previous one ends. The smart contract uses predefined timestamps to govern the start and end of each raffle. This ensures that raffles run continuously, providing users with regular opportunities to participate.',
  },
  {
    question: 'How do I know if I’ve won?',
    answer:
      'After the raffle closes, the winner is determined by a secure random number generated through Chainlink VRF. The results are announced on the dApp, and the reward is automatically transferred to the winner’s wallet. You can check the results and your wallet balance to confirm.',
  },
  {
    question: 'What happens if I miss a raffle?',
    answer:
      'If you miss a raffle, you don’t need to worry. A new raffle begins immediately after the current one ends, so there is always another opportunity to participate. Simply check the dApp regularly to stay updated.',
  },
  {
    question: 'How does the raffle support the SQR token?',
    answer:
      'The raffle system directly supports the SQR token by using portions of ticket purchases for buy-back-and-burn operations. This reduces the circulating supply of SQR and increases its utility within the ecosystem. Additionally, all prize pools are held in SQR, further promoting the token’s usage and value.',
  },
];
